import { FC, useState } from 'react'
import { Share2, Check } from 'lucide-react'

interface Props {
  title?: string
  text?: string
  sessionId: string
}

const ShareButton: FC<Props> = ({
  title = 'Session Report',
  text = 'Check out this verification report',
  sessionId
}) => {
  const [copied, setCopied] = useState(false)

  const handleShare = async () => {
    const url = `${window.location.origin}?recap=${sessionId}`
    // const isMobile =
    //   /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) &&
    //   navigator.maxTouchPoints > 0
    // // Use native share API on mobile if available
    // if (navigator.share && isMobile) {
    //   try {
    //     await navigator.share({
    //       title,
    //       text,
    //       url
    //     })
    //   } catch (err) {
    //     // User cancelled or error - fall through to copy
    //     if ((err as Error).name !== 'AbortError') {
    //       console.error('Share failed:', err)
    //     }
    //   }
    // } else {
    //   // Fallback: copy to clipboard
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Copy failed:', err)
    }
    // }
  }

  return (
    <button
      onClick={handleShare}
      className='flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors'
    >
      {copied ? (
        <>
          <Check size={16} className='text-green-500' />
          <span>Copied!</span>
        </>
      ) : (
        <>
          <Share2 size={16} />
          <span>Share</span>
        </>
      )}
    </button>
  )
}

export default ShareButton
